import { MuteProvider } from "../mute";
import { PauseProvider } from "../pause";

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <MuteProvider>
      <PauseProvider>{children}</PauseProvider>
    </MuteProvider>
  );
};

export default AppProvider;
